import React from 'react';
import {
  Card,
  CardContent,
  Typography,
} from '@mui/material';
import MainLayout from '../components/MainLayout';

const Transcripts: React.FC = () => {
  return (
    <MainLayout title="Transcripts">
      <div className="mb-3">
        <h1 className="text-2xl font-bold text-gray-900">Call Transcripts</h1>
        <p className="text-gray-600 mt-1">View and manage AI sales assistant conversation transcripts</p>
      </div>

      <Card elevation={1}>
        <CardContent className="p-6">
          <Typography variant="h6" gutterBottom>
            Recent Transcripts
          </Typography>
          <Typography variant="body2" color="textSecondary">
            Transcript management functionality will be implemented here.
          </Typography>
        </CardContent>
      </Card>
    </MainLayout>
  );
};

export default Transcripts;